import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BusinessPermissions } from '../interfaces/ip-business-permissions';
import IpErrorResponse from '../interfaces/ip-error-response';
import { LicenceType } from '../interfaces/ip-licence-type';
import { IpAuthService } from './ip-auth.service';
import { IpSnackbarService } from './ip-snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class IpLicenceService {
  private BUSINESS_PERMISSIONS = "../assets/invopay/db/business-permissions.json";
  private LICENCE_TYPES = "../assets/invopay/db/licence-type.json";
  private businessPermissionsSubject: BehaviorSubject<BusinessPermissions | null> =
    new BehaviorSubject<BusinessPermissions | null>(null);
  public currentBusinessPermissions$: Observable<BusinessPermissions | null> =
    this.businessPermissionsSubject.asObservable();
  private licenceTypeSubject: BehaviorSubject<LicenceType | null> =
    new BehaviorSubject<LicenceType | null>(null);
  public currentLicenceType$: Observable<LicenceType | null> =
    this.licenceTypeSubject.asObservable();

  constructor(
    private http: HttpClient,
    private ipAuthService: IpAuthService,
    private ipSnackbarService: IpSnackbarService,
  ) {
    this.ipAuthService.currentSession$.subscribe(session => {
      if (session) {
        this.setBusinessPermissions();
      }
    });
  }

  setBusinessPermissions() {
    const clientId = Number(sessionStorage.getItem('enterpriseId')!);
    this.http.get<BusinessPermissions[]>(this.BUSINESS_PERMISSIONS).subscribe({
      next: businessPermissionsArray => {
        let myBusinessPermissions: BusinessPermissions | undefined;
        businessPermissionsArray.forEach(businessPermissions => {
          if (businessPermissions.clientId === clientId) {
            myBusinessPermissions = businessPermissions;
          }
        });
        if (!myBusinessPermissions) {
          // Default (GOLD) permissions for every client/enterprise
          myBusinessPermissions = businessPermissionsArray[2];
        }
        this.businessPermissionsSubject.next(myBusinessPermissions);
        this.setLicenceType(myBusinessPermissions);
      },
      error: (e: IpErrorResponse) => {
        this.ipAuthService.logOut();
        this.ipSnackbarService.showErrorMessage(e);
      },
    });
  }

  private setLicenceType(businessPermissions: BusinessPermissions) {
    this.http.get<LicenceType[]>(this.LICENCE_TYPES).subscribe(
      licenceTypes => {
        let myLicenceType: LicenceType | undefined;
        licenceTypes.forEach(licenceType => {
          if (licenceType.id === businessPermissions.licenceTypeId) {
            myLicenceType = licenceType;
          }
        });
        if (!myLicenceType) {
          // Default licence (GOLD) for every client/enterprise
          myLicenceType = licenceTypes[2];
        }
        this.licenceTypeSubject.next(myLicenceType);
      }
    );
  }
}
